let copySource = {
    document: {
        title:'购买/赠送点数'
    },
    headerNav:{
        logo:{
            alt:'Marriott Bonvoy',
            link:'https://www.marriott.com.cn/default.mi'
        },
        home: {
            copy: 'Home',
            link: ''
        },
        buy: {
            copy:'购买积分',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=zh-CN&iscid=points_buy_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=zh-CN&iscid=points_buy_cta_em_pr'
        },
        gift: {
            copy:'赠送积分',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=zh-CN&iscid=points_gift_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=zh-CN&iscid=points_gift_cta_em_pr'
        },
        multiply: {
            copy:'将您的积分翻倍',
            stLink: 'https://sso-uat.lxc.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=zh-CN&iscid=points_multiply_plp_web_ev',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=zh-CN&iscid=points_multiply_plp_web_ev'
        },
        mr: {
            copy:'Marriott.com',
            link:'https://www.marriott.com.cn/default.mi'
        },
    },
    hero: {
        lang: 'landing-ch',
        headline: {
            lineOne: '善用积分，畅享欢乐。',
            lineTwo: '立即购买，随时出发。',
        },
        subHeadline : '灵感到来之际，使用积分助您梦想成真。无论是美妙旅程 还是即兴精彩体验，众多理想去处均可为您提供缤纷活动。\n 立即购买或购赠积分。',
        alt:'使用积分畅享免费住宿，畅玩热门目的地。预订心中的梦想旅行。兑换更长时间的住宿。更多礼遇，就在今年。万豪旅享家，旅享不设限。'
    },
    promo: {
        hero: {
            promoLang: 'promo-ch',
            headline: "乐享更多积分。",
            subheadline: "开启随心旅行。",
            body:"3 月 31 日前购买积分，即可获享奖励。想要即刻畅游海滩？ 钟爱此处，想要入住更长时间？ 灵感到来之际，使用积分助您梦想成真。",
        }
    },
    ctas:{
        buy:{
            imgAlt:'从酒店卧室内窗俯瞰城市景观。',
            header:'购买积分',
            copy:'从增添一晚额外住宿，到体验一票难求的演出贵宾礼遇，立即购买\n积分，随时做好准备获享此等礼遇。',
            linkCopy:'购买积分',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=zh-CN&iscid=points_buy_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=buy&language=zh-CN&iscid=points_buy_cta_em_pr'
        },
        gift:{
            imgAlt:'俯瞰大海的酒店阳台和泳池。',
            header:'购赠积分',
            copy:'购买积分赠予亲友, 助力其随时畅游心仪之地。',
            linkCopy:'购赠积分',
            stLink: 'https://uat.ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=zh-CN&iscid=points_gift_cta_em_pr',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=gift&language=zh-CN&iscid=points_gift_cta_em_pr'
        },
        multiply:{
            imgAlt:'Hotel balcony with a pool overlooking the ocean.',
            header:'将您的积分翻倍',
            copy:'已从近期住宿中赚取积分？ 现在，您可以折扣价购买高达 4 倍的积分，让您的下次旅行更加丰富充实。',
            linkCopy:'购买积分，获享优惠',
            stLink: 'https://sso-uat.lxc.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=zh-CN&iscid=points_multiply_plp_web_ev',
            link:'https://ssogateway.points.com/v2/oidc/marriottoidc?ssoProduct=multiply&language=zh-CN&iscid=points_multiply_plp_web_ev'
        },
        membership:{
            imgAlt:'',
            imgSrc: './images/mr_rebrand_register_Placeholder.png',
            header: '成为会员',
            link: 'https://www.marriott.com.cn/loyalty/createAccount/createAccountPage1.mi?enrollmentSourceCode=MSPV',
            copy: '专享房价，赚取积分，兑换免费住宿及更多精彩礼遇。新会员注册加入万豪旅享家计划30天后可购买积分。'
        }
    },
    footer:{
        copyrightOne: '本网站由 Points.com Inc. 代表 Marriott International, Inc. 运营，用于在',
        copyrightLinkTC: 'https://points-ebgt.s3.amazonaws.com/marriott/terms-conditions/bonvoy-terms-and-conditions-ZH-CN.html',
        copyrightTwo: 'Points.com Inc. 的条款和条件',
        copyrightThree: '下购买 Marriott Bonvoy Points。与购买交易相关的 Marriott Bonvoy Points 之发放和使用需遵循',
        copyrightLinkTwo: 'https://www.marriott.com/loyalty/terms/default.mi',
        copyrightFour: 'Marriott Bonvoy 活动规则',
        copyrightFive: '和',
        copyrightLinkThree: 'https://www.marriott.com/about/privacy.mi',
        copyrightSix: '隐私政策',
        copyrightSeven: '。',

        options: {
            de: "Deutsch",
            es: "Español",
            en:'English',
            fr: 'Français',
            it: 'Italiano',
            jp:'日本語',
            pt:'Português',
            ch:'国际'
        },
        footerbar:{
            logo: "./images/rebrand/bonvoy_logo_cn.png",
            grp1: "奢华",
            grp2: "高端",
            grp3: "精选",
            grp4: "中端",
            grp5: "长住"
        },
        langIconSrc: './images/Icon-Globe.svg',
        langIconAlt: '国际',
        tracking:{
            doNotSell:{
                copy:'不要出售我的个人信息',
                href:'https://www.marriott.com/about/ccpa/do-not-sell.mi'
            },
            prefs: {
                copy:'跟踪首选项',
                href:'https://consent-pref.trustarc.com/?layout=gdpr&type=marriottgdpr&site=marriottgdpr.com&action=notice&country=ca&locale=en&behavior=implied&irm=undefined&from=https://consent.trustarc.com/'
            }
        },
        terms:{
            copy:'使用条款',
            href:'https://www.marriott.com.cn/about/terms-of-use.mi'
        },
        programTerms:{
            copy:'旅享家计划细则及条款',
            href:'https://www.marriott.com.cn/loyalty/terms/default.mi'
        },
        privacy:{
            copy:'隐私中心',
            href:'https://www.marriott.com.cn/privacy.mi'
        },
        accessibility:{
            copy:'数字辅助功能',
            href:'https://www.marriott.com.cn/digital-accessibility.mi'
        },
        siteMap:{
            copy:'网站地图',
            href:'https://www.marriott.com.cn/sitemap.mi'
        },
        help:{
            copy:'帮助',
            href:'https://www.marriott.com.cn/help.mi'
        },
    }
    
}

export default copySource

